import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppContext from '../AppContext';
import { storeRedirectUrl } from '../utils/redirectUtils';

/**
 * ProtectedRoute component that handles 404 redirects for non-logged-in users
 * This component is used as a catch-all route when user is not logged in
 * It stores the attempted URL and redirects to login
 */
const ProtectedRoute = () => {
  const { isLoggedIn } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      // Store the current URL with query parameters for redirect after login
      const fullUrl = location.pathname + location.search;
      storeRedirectUrl(fullUrl);
      
      // Redirect to login with a redirect parameter
      navigate(`/?redirect=${encodeURIComponent(fullUrl)}`, { replace: true });
    }
  }, [isLoggedIn, location, navigate]);

  // This component doesn't render anything, it just redirects
  return null;
};

export default ProtectedRoute;